module.exports = __webpack_public_path__ + "img/Partners 10.f6d4b044.png";